/**
 * De beschrijvingsregel onder de paginakop van één ingevulde vragenlijst.
 *
 * Onbekende onderdelen vallen weg in plaats van als leeg streepje te
 * verschijnen — een lege waarde betekent hier "nog niet geladen", en dat is
 * geen bewering die de lezer moet zien.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} parts
 * @param {string} [parts.dateLabel] - De inzenddatum, al opgemaakt.
 * @param {string} [parts.momentTitle] - Titel van het meetmoment.
 * @param {number} [parts.answerCount] - Aantal antwoorden in deze inzending.
 * @returns {string} De regel, of '' als er niets bekend is.
 */
const submissionHeaderDescription = ({ dateLabel, momentTitle, answerCount } = {}) => [
    dateLabel,
    momentTitle && `Meetmoment ${momentTitle}`,
    answerCount > 0 && `${answerCount} ${answerCount === 1 ? 'antwoord' : 'antwoorden'}`,
].filter(Boolean).join('  ·  ');

export default submissionHeaderDescription;
